import creditCardType from 'credit-card-type';
import { createSelector } from 'reselect';
import { CreditCardProvider, PaymentCategory } from '../../../__generated__/graphql';
import {
  selectAvailablePaymentMethodsForCheckout,
  selectCurrentOtherPaymentMethod,
} from '../components/form/selectors';
import type { CreditCardInput } from '../../../__generated__/graphql';
import type { CheckoutReduxForm } from '../types/checkout-redux-form';
import type { PaymentMethod } from '@ticketmaster/tm1pos-web-shared/model/permissions';
import type { EmvTransaction } from '@ticketmaster/tm1pos-web-shared/payment/emvPaymentModule-types';

export const tmdsCreditCard = (emvTransaction: EmvTransaction): CreditCardInput => ({
  provider: CreditCardProvider.Tmds,
  tmds: {
    bin: emvTransaction.bin,
    cardType: emvTransaction.paymentDetails.cardType,
    expirationMonth: emvTransaction.expirationMonth,
    expirationYear: emvTransaction.expirationYear,
    hostToken: emvTransaction.hostToken,
    lastFourDigits: emvTransaction.paymentDetails.lastFourDigits,
    merchantReceiptData: emvTransaction.merchantReceiptData,
    nameOnCard: emvTransaction.nameOnCard,
    transactionId: emvTransaction.transactionId,
    token: emvTransaction.token,
  },
});
export const pdgCreditCard = (emvTransaction: EmvTransaction): CreditCardInput => ({
  provider: CreditCardProvider.Pdg,
  pdg: {
    paymentReference: emvTransaction.paymentReference,
  },
});
export const authOffCreditCard = (form: CheckoutReduxForm) => {
  const cardType = form.manualCardEntry ? form.creditCardTypes.id : creditCardType(form.accountNumber)[0].type;
  const [month, year] = form.expDate.split('/');
  return {
    provider: CreditCardProvider.AuthorizationOff,
    authorizationOff: {
      authorizationCode: form.authCode,
      cardType,
      holderName: form.cardHolderName,
      expirationYear: year,
      expirationMonth: month,
    },
  };
};

function findInPaymentCategoryEnum(category?: string) {
  return Object.entries(PaymentCategory)
    .find(([, value]) => value === category)
    ?.at(0);
}

export const selectOtherPaymentCategory = createSelector(
  (state: any) => state.event && selectAvailablePaymentMethodsForCheckout(state),
  selectCurrentOtherPaymentMethod,
  (availablePaymentMethodsForCheckout, otherPaymentMethod): PaymentCategory => {
    if (!availablePaymentMethodsForCheckout || !otherPaymentMethod?.id) {
      return PaymentCategory.Unknown;
    }
    const paymentMethod = availablePaymentMethodsForCheckout.allMethods.find(
      (method: PaymentMethod) => method.type.toLowerCase() === otherPaymentMethod.id.toLowerCase(),
    );
    const category = findInPaymentCategoryEnum(paymentMethod?.category);
    if (!category) {
      return PaymentCategory.Unknown;
    }
    return PaymentCategory[category as keyof typeof PaymentCategory];
  },
);

export const otherPayment = (form: CheckoutReduxForm, otherPaymentCategory: PaymentCategory) => ({
  name: form.otherPaymentMethod.id,
  value: form.paymentInfo,
  category: otherPaymentCategory,
});
